export const imageContainer = () => ({
    height: '100%',

    '> div': {
        height: '100%',
    },
});
